import type { CallActionConfig, CallActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { type ActionFlowNode, resolveVariable } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleCallStream = async (
    node: ActionFlowNode<CallActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config || !config?.phone) {
        throw new Error(t('configurationNotPerfect'))
    }

    const phone = handleCall(config, params)

    return await Promise.resolve({
        type: 'args',
        success: true,
        data: [{ id: '', name: 'phone', innerType: 'TEXT', value: phone }]
    })
}

export const handleCall = (config: CallActionConfig, params: ExecuteActionParams) => {
    const phone = resolveVariable(config.phone, params)
    const phoneString = safeToString(phone)
    if (phoneString) {
        const a = document.createElement('a')
        a.href = `tel:${phoneString}`
        a.click()
        a.remove()
    }

    return phoneString
}
